export enum StudentSortBy {
    ID = "id",
    STATUS = "status",
    PROGRESS = "overallProgress",
};
